var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "px-1", attrs: { id: "voiceRecorder" } }, [
    !_vm.isRecording
      ? _c(
          "div",
          [
            _c(
              "md-button",
              {
                staticClass: "actionBtn",
                on: {
                  click: function () {
                    return _vm.startRecord()
                  },
                },
              },
              [
                _c("md-icon", { staticStyle: { color: "#1e1e2d" } }, [
                  _vm._v("mic"),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "voice-record-phase" },
          [
            _c("a-progress", {
              staticClass: "voice-record-phase-progress",
              attrs: {
                percent: Math.ceil((_vm.duration / _vm.maxSec) * 100),
                status: "active",
              },
            }),
            _vm._v(" "),
            _c(
              "md-button",
              {
                staticClass: "actionBtn",
                on: {
                  click: function () {
                    return _vm.stopRecord()
                  },
                },
              },
              [
                _c("md-icon", { staticStyle: { color: "green" } }, [
                  _vm._v("check"),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "md-button",
              {
                staticClass: "actionBtn",
                on: {
                  click: function () {
                    return _vm.stopRecord(true)
                  },
                },
              },
              [
                _c("md-icon", { staticStyle: { color: "red" } }, [
                  _vm._v("stop"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }